import { customerApi } from "../../utils/apiConfig";

export const uploadtStandart = (userId, file, title, description, reminder) => {
  const formData = new FormData();
  formData.append("userId", userId);
  formData.append("title", title);
  formData.append("description", description);
  formData.append("excel", file);

  if (reminder?.reminderActive) {
    formData.append("reminderActive", "true");

    formData.append(
      "reminder",
      JSON.stringify({
        startDate: reminder.startDate,
        endDate: reminder.endDate,
        note: reminder.note || "",
        notifyBefore: reminder.notifyBefore || 30, //  düz sayı gönder
      })
    );
  }

  return customerApi.post("/uploadStandartDocument", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const updateStandart = (
  updatedId,
  userId,
  file,
  title,
  description,
  reminder
) => {
  const formData = new FormData();
  formData.append("updatedId", updatedId);
  formData.append("userId", userId);
  formData.append("title", title);
  formData.append("description", description);

  if (file) {
    formData.append("excel", file);
  }

  if (reminder?.reminderActive) {
    formData.append("reminderActive", "true");

    formData.append(
      "reminder",
      JSON.stringify({
        startDate: reminder.startDate,
        endDate: reminder.endDate,
        note: reminder.note || "",
        notifyBefore: reminder.notifyBefore || 30,
      })
    );
  }

  return customerApi.post("/updateStandartDocument", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const deleteStandartDocument = (userId, deletedId) => {
  return customerApi.post(
    "/deleteStandartDocument",
    JSON.stringify({ userId, deletedId }),
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    }
  );
};

export const getStandart = () => {
  return customerApi.get("/getUploadStandartDocument", {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};
